import type { AskAIDialogMessageType } from 'types/chat/props';

export const AI_SESSION_KEY_PREFIX = 'ai_session_';

export type AiSessionStoredV1 = {
  v: 1;
  messages: AskAIDialogMessageType[];
  updatedAt: string;
};

export function aiSessionStorageKey(chatId: number | string): string {
  return `${AI_SESSION_KEY_PREFIX}${chatId}`;
}

export function loadAiSessionFromBrowser(chatId: number | string): AiSessionStoredV1 | null {
  try {
    const raw = localStorage.getItem(aiSessionStorageKey(chatId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AiSessionStoredV1;
    if (parsed?.v !== 1 || !Array.isArray(parsed.messages)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveAiSessionToBrowser(chatId: number | string, messages: AskAIDialogMessageType[]): void {
  const payload: AiSessionStoredV1 = {
    v: 1,
    messages,
    updatedAt: new Date().toISOString(),
  };
  try {
    localStorage.setItem(aiSessionStorageKey(chatId), JSON.stringify(payload));
  } catch {
    /* quota */
  }
}

export function clearAiSessionInBrowser(chatId: number | string): void {
  try {
    localStorage.removeItem(aiSessionStorageKey(chatId));
  } catch {
    /* ignore */
  }
}
